import { createAction, props } from "@ngrx/store";
import { HolidayGroup } from "../../models/holiday-group";

export const findHolidayGroupAct = createAction('findHolidayGroupEffect', props <{ id: number }>());
export const loadHolidayGroupByIdAct = createAction('loadHolidayGroupByIdEffect', props<{ holidayGroup: HolidayGroup }>());

export const resetHolidayGroupAct = createAction('resetHolidayGroupEffect');

export const updateHolidayGroupAct = createAction('updateHolidayGroupEffect', props<{ holidayGroupUpdated: HolidayGroup }>());
export const updateSuccessHolidayGroupAct = createAction('updateSuccessHolidayGroupEffect', props<{ holidayGroupUpdated: HolidayGroup }>());

export const saveHolidayGroupAct = createAction('saveHolidayGroupEffect', props<{ holidayGroupNew: HolidayGroup }>());
export const saveSuccessHolidayGroupAct = createAction('saveSuccessHolidayGroupEffect', props<{ holidayGroupNew: HolidayGroup }>());

export const setViolationsHolidayGroupAct = createAction('setViolationsHolidayGroupEffect', props<{ holidayGroupForm: HolidayGroup, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
